import { Configuration } from "../configs/Configuration";

let pilotId = Configuration.getConfiguration().pilotId;

export const setPilotId = (externalPilotId) => {
    pilotId = externalPilotId;
}

export const getPilotId = () => {
    return pilotId;
}